import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { toggleSupport, sendFeedback, toggleModalFeedbackThanks, clearFeedbackSentStatus } from '../../../redux/main/main.actions';
import { selectIsModalSupportEnabled, selectModalSupportData, selectFeedbackSentStatus } from '../../../redux/main/main.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import Modal from '../Modal/Modal';
import './ModalFeedback.scss';


export const ModalFeedback = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalSupportEnabled);
    const modalData = useSelector(selectModalSupportData);

    const inputRef = useRef(null);
    const textareaRef = useRef(null);

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const [contentType, setContentType] = useState('');

    const feedbackSentStatus = useSelector(selectFeedbackSentStatus);
    const [sentCount, setSentCount] = useState(0);

    useEffect(() => {
        if (!modalData?.type) return;

        setContentType(modalData?.type || 'feedback');
        return () => { };
    }, [modalData]);

    useEffect(() => {
        if (feedbackSentStatus === 'success') {
            dispatch(toggleSupport(null));
            dispatch(toggleModalFeedbackThanks(contentType));

            setTimeout(() => {
                setEmail('');
                setMessage('');
                setSentCount(0);
            }, 300);

        } else if (feedbackSentStatus === 'error') {
            if (textareaRef.current && (window.innerWidth >= 1000)) {
                textareaRef.current.focus();
            }
        }

        return () => {
            dispatch(clearFeedbackSentStatus());
        };
    }, [feedbackSentStatus]);

    const handleSave = () => {
        if (!message) {
            dispatch(showNotify({ message: 'please_enter_message' }));
            if (textareaRef.current && (window.innerWidth >= 1000)) {
                textareaRef.current.focus();
            }
            return;
        }
        if (!validateEmail(email.trim())) {
            dispatch(showNotify({ message: 'invalid_email' }));
            if (inputRef.current && (window.innerWidth >= 1000)) {
                inputRef.current.focus();
            }
            return;
        }

        if (!message) return;
        if (!email) return;
        if (sentCount > 4) return;

        const data = {
            message,
            email: email.trim(),
            t: modalData?.type,
            i: 'p',
            j: 'm',
        };

        setSentCount(sentCount + 1);
        dispatch(sendFeedback(data));
    };

    const handleCancel = () => {
        dispatch(toggleSupport(null));
        setTimeout(() => {
            setEmail('');
            setMessage('');
            setSentCount(0);
        }, 300);
    };

    const handleMessageChange = (e) => {
        if (e.target.value?.length < 1200) {
            setMessage(e.target.value);
        }
    }

    const handleEmailChange = (e) => {
        if (e.target.value?.length < 100) {
            setEmail(e.target.value);
        }
    }


    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey) {
            e.preventDefault();
            handleSave();
        }
    };

    const validateEmail = (emailValue) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(emailValue);
    };


    if (!contentType) return null;

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-feedback-main`}
            // modalClass={`modal-feedback-main ${modalData?.type === 'main' ? 'feedback-canvas' : ''} ${viewType}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t(`m_feedback.${contentType}.name`)}</div>
            <div className="modal-content-body">
                <textarea
                    maxLength={1000}
                    ref={textareaRef}
                    autoComplete="off"
                    autoFocus={(window.innerWidth >= 1000)}
                    spellCheck="false"
                    placeholder={t(`m_feedback.${contentType}.desc`)}
                    value={message}
                    onChange={handleMessageChange}
                    onKeyDown={handleKeyDown}
                    onFocus={(e) => {
                        requestAnimationFrame(() => {
                            setTimeout(() => {
                                e.target.scrollIntoView({
                                    behavior: 'auto',
                                    block: 'center',
                                });
                            }, 300);
                        });
                    }}
                />
                <input
                    ref={inputRef}
                    maxLength={150}
                    autoComplete="off"
                    spellCheck="false"
                    placeholder={t('b.email_address')}
                    value={email}
                    onChange={handleEmailChange}
                    onKeyDown={handleKeyDown}
                />
                <button
                    disabled={sentCount > 4}
                    onClick={() => handleSave()}>{t('b.send')}</button>
            </div>
        </Modal>
    );
};

export default ModalFeedback;
